import type { SchoolYearEntity } from '@/core/infrastructure/schemas/school/year/SchoolYearSchema'
import { SchoolYearSchema } from '@/core/infrastructure/schemas/school/year/SchoolYearSchema'
import { EntityValidator } from '@/core/infrastructure/utils/EntityValidator'

/**
 * User domain class
 */
export default class SchoolYear {
  readonly schoolYearId: number
  readonly startDate: string
  readonly endDate: string
  readonly name: string
  readonly isCurrent: boolean
  readonly isPast: boolean
  readonly isFuture: boolean

  constructor(year: SchoolYearEntity) {
    this.schoolYearId = year.schoolYearId
    this.startDate = year.startDate
    this.endDate = year.endDate
    this.name = year.name
    this.isCurrent = year.isCurrent
    this.isPast = year.isPast
    this.isFuture = year.isFuture
  }

  /**
   * Crée une instance de SchoolYear à partir de données brutes
   */
  public static create(data: unknown): SchoolYear {
    return EntityValidator.validateAndCreate(SchoolYearSchema, data, SchoolYear, 'SchoolYear')
  }
}
